interface PrismicImageOptions {
  w: number;
  h: number;
  fit: string;
}

const createOptions = (w: number, h: number) => ({ w, h, fit: 'crop' });

export const slideImageOptions = {
  thumbnail: createOptions(75, 51),
  x1: createOptions(250, 170),
  x2: createOptions(500, 340),
  x3: createOptions(750, 510),
};

export const composePrismicImageUrl = (imageUrl: string, options: PrismicImageOptions) => {
  const url = new URL(imageUrl);

  if (url.searchParams.has('rect')) {
    url.searchParams.delete('rect');
  }

  Object.entries(options).forEach(([key, value]) => {
    if (url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.append(key, value);
    }
  });

  return url.href;
};
